// extracted by mini-css-extract-plugin
export default {"absence-month":"absence-month--BGrwQ event-month--atv6w","absenceMonth":"absence-month--BGrwQ event-month--atv6w"};